import { SYMBOLS } from '../inversify/symbols'
import { inject, injectable } from '~/container'
import { PuFetchInstance } from '~/utility/http'
import { datepickerAvailabilityResultsSchema } from './schemas'
import { DatepickerAvailabilityService } from './service'
import { DatepickerAvailabilityResultsDay } from './types'
import { getUrlPrefix } from '~~/lang/locales'

@injectable()
export class DatepickerAvailabilityServiceFetch
implements DatepickerAvailabilityService
{
  @inject(SYMBOLS.PuFetchInstance)
  protected puFetch: PuFetchInstance

  async get(
    langCode: string,
    slug: string,
    categories: Array<string> = [],
    pitchtypeId?: string,
  ): Promise<DatepickerAvailabilityResultsDay[]> {
    const params = categories.reduce((categoryParams, id) => {
      categoryParams.append('type', String(id))
      return categoryParams
    }, new URLSearchParams())
    if (pitchtypeId) {
      params.append('pitchtype_id', String(pitchtypeId))
    }
    const urlPrefix = getUrlPrefix(langCode)
    const response = await this.puFetch.get(
      `/_/fallback${urlPrefix}/_/datepicker/${slug}`,
      { params },
    )
    return datepickerAvailabilityResultsSchema.parse(response)
  }
}
